import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHammer, faWindowRestore, faToolbox } from "@fortawesome/free-solid-svg-icons";
import "./Activites.css";
import logoTRHr from '../assets/TRH-illustration-pose.jpg';

const ActivitesSection = () => {
  return (
    <section id="activites" className="section fade-in">
      <div className="sectionContent">
        <img src={logoTRHr} alt="TRH Menuiserie" className="logor" />
        <h4>Votre partenaire en menuiserie et vitrage</h4>
       
        <p><strong>Mon approche est simple :</strong> <br /> comprendre vos besoins, vous conseiller et livrer un travail soigné.</p>
        <p><strong>Mon engagement :</strong> <br/>offrir un service sur-mesure et une attention aux détails qui font toute la différence.</p>
        
        {/* Section des trois blocs d'activités */}
        <div className="activity-grid">
          <div className="activity-block">
            <FontAwesomeIcon icon={faHammer} className="activity-icon" />
            <h5>Installation</h5>
            <p>Pose soignée et personnalisée de menuiseries aluminium et PVC.<br />Pose de volet roulant/battant et moustiquaire</p>
          </div>
          <div className="activity-block">
            <FontAwesomeIcon icon={faWindowRestore} className="activity-icon" />
            <h5>Remplacement</h5>
            <p>Remplacement rapide et professionnel pour tous types de vitrages.</p>
          </div>
          <div className="activity-block">
            <FontAwesomeIcon icon={faToolbox} className="activity-icon" />
            <h5>Entretien et Réparation</h5>
            <p>Services de maintenance pour assurer la durabilité de vos installations.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ActivitesSection;
